import Vue from 'vue'
import VueRouter from 'vue-router'
//import store from './store'

// Views
import Error from './views/Error'
import EmailVerification from './views/EmailVerification'
import EmailVerificationOnboarding from './views/EmailVerificationOnboarding'

Vue.use(VueRouter)

const routes = [
  { 
    path: '/onboarding/:token', 
    component: EmailVerificationOnboarding, 
    name: 'email-verification-onboarding', 
  },
    { 
      path: '/account/:token', 
      component: EmailVerification, 
      name: 'email-verification', 
    },
    { 
      path: '*', 
      component: Error, 
      name: 'error', 
    },
]

export default new VueRouter({mode: 'history', routes})
